<div class="flex-container">
    <div class="flex-item">
        <h3 class="margin-top-0">{{ 'common.labels.searchCriteria' | transloco }}</h3>
        <div>
            <div class="flex-container">
                <span class="flex-item">{{ 'common.labels.name2' | transloco }}</span>
                <span class="flex-item-2">{{ order.businessSearchCriteria!.name }}</span>
            </div>
        </div>
    </div>
</div>